


export default {
  data() {
    return {
      disclosure: null,
      loading: false,
      showAiSummaryModal: false,
      aiSummaryData: null,
      aiFinanceData: null,
      aiSummaryDataError: null,
      aiFinanceDataError: null,
    }
  },


  mounted() {
    this.$bus.$on('openAiSummaryModal', this.openAiSummaryModal)
  },
  beforeDestroy() {
    // Always clean up listeners!
    this.$bus.$off('openAiSummaryModal', this.openAiSummaryModal)
  },
  methods: {
    openAiSummaryModal(data) {
      this.disclosure = data.data
      this.showAiSummaryModal = true
      this.getSummaryData(data)
    },

    async getSummaryData(data) {
      this.loading = true
      this.aiSummaryDataError = false
      this.aiFinanceDataError = false

      // Your condition
      const isFinancialReport = data.data.resources.some(item => item.type === "financial_reports");

      try {
        const disclosureId = data.data.id
        const resourceIDs = data.data.resources.map(resource => resource.id);
        // const summaryUrl = `https://api-doc-ai.dfm.ae/summary?pk=document%23${id}%23${resId}`
        // const financeUrl = `https://api-doc-ai.dfm.ae/extracted-document?pk=document%23${id}%23${resId}`

        let summaryRes = null
        let financeRes = null

        // Only fetch summary if isFinancialReport is false
        if (!isFinancialReport) {
          try {
            const summaryRes = await Promise.all(
              resourceIDs.map(resourceId =>
                fetch(`https://api-doc-ai.dfm.ae/summary?pk=document%23${disclosureId}%23${resourceId}`).then(res => res.json())
              )
            );
            // `summaryRes` now contains the parsed JSON responses
            this.aiSummaryData = summaryRes
            if (summaryRes[0].error || summaryRes[0].data?.status == 'error') {
              this.aiSummaryDataError = true
            }

          } catch (error) {
            this.aiSummaryDataError = true;
            return null
          }
        }

        // Only fetch finance if isFinancialReport is true
        if (isFinancialReport) {
          try {
            const financeRes = await Promise.all(
              resourceIDs.map(resourceId =>
                fetch(`https://api-doc-ai.dfm.ae/extracted-document?pk=document%23${disclosureId}%23${resourceId}`).then(res => res.json())
              )
            );
            // `financeRes` now contains the parsed JSON responses
            // console.log('financeRes', financeRes)
            // console.log('error', financeRes[0].error)
            this.aiFinanceData = financeRes
            if (financeRes[0].error) {
              this.aiFinanceDataError = true
            }
          } catch (error) {
            this.aiFinanceDataError = true;
            return null
          }

        }

      } catch (error) {
        this.aiSummaryDataError = true
        this.aiFinanceDataError = true
        console.error('Unexpected error:', error)
      } finally {
        this.loading = false
      }
    },



    beforeOpen() {
      this.$emit('modal-before-open')
    },
    opened() {
      this.$emit('modal-opened')
    },
    beforeClose() {
      this.$emit('modal-before-close')
    },
    closed() {
      this.disclosure = null
      this.aiSummaryData = null
      this.aiSummaryDataError = null
      this.aiFinanceData = null
      this.aiFinanceDataError = null
      this.$emit('modal-closed')
    },
  }
}
